// extracted by css-extract-rspack-plugin
export default {"guidancePopover":"guidancePopover-A9ZZyn","mask":"mask-WBxa0h","skip":"skip-wf8obE"};